import { render } from "./SilentRenew.vue?vue&type=template&id=a816bea2"
import script from "./SilentRenew.vue?vue&type=script&lang=js"
export * from "./SilentRenew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__